import { actionClient } from '@/api'

export default {

  namespaced: true,

  state: {
  },


  mutations: {
  },

  actions: {

    async orderReport({ commit }, query) {
      query = query ? JSON.stringify(query) : undefined

      return await actionClient.get('order-report', {query: { query }, config: {
          responseType: 'blob'
        }})
    },

    async activityProductReport({ commit }, query) {
      query = query ? JSON.stringify(query) : undefined

      return await actionClient.get('activity-product-report', {query: { query }, config: {
          responseType: 'blob'
        }})
    }
  }

}
